import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FileOutlined, WarningOutlined } from '@ant-design/icons';
import moment from 'moment';
import { Modal, Button, Loader, Table } from 'react-inv-forms';

import { closeProtocolModal, downloadProtocol, printOutProtocol } from '../../../redux/appConfig/actions';
import { getProtocolState } from '../../../redux/appConfig/selectors';
import { RootState } from '../../../redux/reducers';

import StringBuilder from '../../../helpers/StringBuilder';

import PdfActionButtons from '../../UI/PdfActionButtons';
import { Description, TitleBox, FlexContainer, ProtocolNotGeneratedSection } from './GenerateProtocol.style';

type MapStateToProps = ReturnType<typeof mapStateToProps>;
type MapDispatchToProps = ReturnType<typeof mapDispatchToProps>;

type Props = MapStateToProps & MapDispatchToProps;
/**
 * Komponent modala generowania protokołu
 *
 */
export const GenerateGroupProtocolModal = ({
  protocolModal,
  downloadProtocol,
  printOutProtocol,
  closeProtocolModal,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  const { opened, protocols, columns, loading, semestrAkademicki, rokAkademicki } = protocolModal;

  const tableData = protocols.map(protocol => ({
    ...protocol.data,
    dataWygenerowania: protocol.pdfGenerateStatus.status
      ? moment.unix(protocol.data.dataWygenerowania / 1000).format('YYYY-MM-DD')
      : '-', //zamiana z milisekund na sekundy
    key: protocol.data.protId,
    actions: (
      <PdfActionButtons
        onDownload={() => downloadProtocol(protocol.data.protId)}
        onPrintOut={() => printOutProtocol(protocol.data.protId)}
        printOutInProcess={protocol.printInProcess}
        downloadInProcess={protocol.downloadInProcess}
        pdfGenerateStatus={protocol.pdfGenerateStatus}
      />
    ),
  }));

  return (
    <Modal
      visible={opened}
      onCancel={closeProtocolModal}
      bodyStyle={{ maxHeight: '80%', overflow: 'auto' }}
      width='90%'
      title={
        <span>
          <FileOutlined style={{ lineHeight: '0', marginRight: '8px', fontSize: '18px' }}></FileOutlined>
          {t('GENERATE_PROTOCOL_MODAL')}
        </span>
      }
      className='modal__responsive cyGenerateProtocolModal'
      footer={[
        <Button key='back' onClick={closeProtocolModal}>
          {t('CLOSE')}
        </Button>,
      ]}
    >
      {loading ? (
        <Loader style={{ position: 'relative', left: '50%', fontSize: '24px' }} />
      ) : (
        <>
          <FlexContainer>
            <TitleBox>
              <h3>{t('GENERATE_PROTOCOL_MODAL_AVAILABLE_PROTOCOLS')}: </h3>
              {protocols.find(protocol => !protocol.pdfGenerateStatus.status) && (
                <ProtocolNotGeneratedSection>
                  <WarningOutlined />
                  {t('PROTOCOL_NOT_GENERATED_MODAL')}
                </ProtocolNotGeneratedSection>
              )}
            </TitleBox>
            <div>
              <h3>
                {t('PRZYDZIAL_LIST_SEMESTRAKADEMICKI')}
                :&nbsp;
              </h3>
              {rokAkademicki && semestrAkademicki ? (
                <Description>{StringBuilder.buildReadableSemester(Number(rokAkademicki), semestrAkademicki)}</Description>
              ) : null}
            </div>
          </FlexContainer>
          <Table columns={columns} dataSource={tableData} pagination={false} />
        </>
      )}
    </Modal>
  );
};

const mapStateToProps = (state: RootState) => ({
  protocolModal: getProtocolState(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  closeProtocolModal: () => dispatch(closeProtocolModal()),
  downloadProtocol: (protId: Protocol.Basic['protId']) => dispatch(downloadProtocol(protId)),
  printOutProtocol: (protId: Protocol.Basic['protId']) => dispatch(printOutProtocol(protId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GenerateGroupProtocolModal) as React.ComponentType<any>;
